<template>
	<div>
		<el-container style="position: absolute;top:0;bottom: 0;left: 0;right: 0;overflow: hidden;font-size:12px">
			<el-container style="height: 100%;">
				<!-- 侧边布局 -->
				<el-aside :width="menuwidth" :class="menuClass">
					<el-menu class="el-menu-vertical-demo left-menu-class"  :default-active="slideMenuActive" @select="slideSelect" style="height: 100%;overflow-y: auto;" active-text-color="#ff9561" :collapse="isCollapse" >
						<div style="height: 60px;box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 10px;padding: 2px;">
							<div style="width: 100%;height: 60px;align-items:center;justify-content: center;display: flex;">
								<!-- <img style="height: 70%;object-fit:contain;"  v-if="isCollapse" src="../assets/img/logo.png" alt=""> -->
								
								
								<!-- <img style="height: 70%;object-fit:contain;" v-else src="../assets/img/black.png" alt=""> -->
								
								<div style="height: 100%;display: flex;align-items: center;width: 100%;justify-content: center;"> 
								<img v-if="user.is_cms_logo" style="height: 70%;object-fit:contain;flex-shrink: 0;"  :src="user.cms_logo?user.cms_logo:defaultLogo" class="ml-2" alt="">				
								<div v-if="!isCollapse" class="ml-3" :class="user.is_cms_logo?'':'text-center'" style="font-size: 23px;font-weight: bold;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;flex: 1;">{{user.cms_name?user.cms_name:'FF Cloud'}}</div>
								</div>
							</div>
						</div>
						
						
						<!-- 账户信息 -->
						<div class="py-3 pl-2" style="display: flex;align-items: center;width: 100%">
							<!--<el-avatar style="flex-shrink: 0;" class="mr-2" size="large" :src="user.head?user.head:user_mo"></el-avatar>	 -->
							<div v-if="!isCollapse" style="flex: 1; overflow: hidden;">
								<div class="mb-1" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;font-weight:700; font-size:14px">
									{{user.name}}
								</div>
								<!-- <div style="word-wrap: break-word; word-break: break-all; font-size:13px">

									{{ user.username }}
								</div> -->
								<div style="display: flex; font-size: 13px;">
									<span style="width: 5px; height: 5px; border-radius: 50%; background-color: green; margin-top: 9px; margin-right: 6px; flex-shrink: 0;"></span>
									<div style="word-wrap: break-word; word-break: break-all;">
										{{ user.username }}
									</div>
								</div>
							</div>
						</div>
						
						<el-menu-item class="xial" v-if="item.child.length === 0" :index="index|numToString" v-for="(item,index) in slideMenus" :key="index" >
							<i class="iconfont" :class="item.icon"></i>
							<span slot="title">{{item.name}}
								<el-badge v-if="item.is_num &&  num_list[item.is_num]>0"  :value="num_list[item.is_num]" :max="99" class="item ml-2"></el-badge>
							</span>
						</el-menu-item>

						<el-submenu :index="index | numToString" v-else>
							<template slot="title">
								<i class="iconfont" :class="item.icon"></i>
								<span>
								{{ item.name }}
								<el-badge
									v-if="item.is_num && num_list[item.is_num] > 0"
									:value="num_list[item.is_num]"
									:max="99"
									class="item ml-2"
								></el-badge>
								</span>
							</template>

							<!-- 二级菜单循环 -->
							<template v-for="(child2, index2) in item.child">
								<!-- 有三级 -->
								<el-submenu
								v-if="child2.child && child2.child.length > 0"
								:index="`${index}_${index2}`"
								:key="`${index}_${index2}`"
								>
								<template slot="title">
									<i class="iconfont" :class="child2.icon"></i>
									<span>
									{{ child2.name }}
									<el-badge
										v-if="child2.is_num && num_list[child2.is_num] > 0"
										:value="num_list[child2.is_num]"
										:max="99"
										class="item ml-2"
									></el-badge>
									</span>
								</template>

								<!-- 三级菜单 -->
								<el-menu-item
										v-for="(child3, index3) in child2.child"
										:key="`${index}_${index2}_${index3}`"
										:index="`${index}_${index2}_${index3}`"
									>
										<i class="iconfont" :class="child3.icon"></i>
										<span>
										{{ child3.name }}
										<el-badge
											v-if="child3.is_num && num_list[child3.is_num] > 0"
											:value="num_list[child3.is_num]"
											:max="99"
											class="item ml-2"
										></el-badge>
										</span>
									</el-menu-item>
									</el-submenu>

									<!-- 没有三级，直接是二级项 -->
									<el-menu-item
									v-else
									:key="`${index}_${index2}`"
									:index="`${index}_${index2}`"
									>
									<i class="iconfont" :class="child2.icon"></i>
									<span>
										{{ child2.name }}
										
										<el-badge
										v-if="child2.is_num && num_list[child2.is_num] > 0"
										:value="num_list[child2.is_num]"
										:max="99"
										class="item ml-2"
										></el-badge>
									</span>
								</el-menu-item>
							</template>
						</el-submenu>
						<div style="width: 100%;height: 100px;"></div>
					</el-menu>
				</el-aside>

				<!-- 主布局 -->
				<el-main class="bg-light" style="padding:0px; padding-bottom: 60px;  position: relative;" v-loading="loading">
				     <el-header class="d-flex align-items-center" style=" padding: 0px; background-color: #fff;box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);position: sticky; top: 0;width: 100%;z-index: 999;">
						<div class="mr-auto d-flex align-items-center" :class="is_phone?'pl-3':''">
							<div ref="memuicon" class="ml-4" style="color: #545c64;font-size: 22px;cursor: pointer;">
								<i @click="handleEdit()" 
								:class="[isCollapse?'el-icon-s-fold':'el-icon-s-unfold']"></i>
							</div>
						</div>
						
						<!-- <div ref="menuicon" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
							
								<span class="el-dropdown-link">
									{{$t('layout.account')}}
								</span>
								<el-select model="1" size="small" filterable :placeholder="$t('system.select')">
										<el-option  :label="$t('status.all')" value="1">
										</el-option>
									</el-select>
							
						</div> -->
						<!-- <div ref="menuicon" style="display: flex; align-items: center; color: #545c64; font-size: 22px; cursor: pointer; padding: 20px;">
							<span class="el-dropdown-link">
								{{$t('layout.account')}}
							</span>
							<el-select style="margin-left: 5px;" v-model="user.ac_id" size="small" filterable :placeholder="$t('layout.noAcid')">
								<el-option :label="$t('status.all')" value="1"></el-option>
								<el-option v-for="item in user.ac_list" :key="item.id" :label="item.ac_id" :value="item.id">
								</el-option>
							</el-select>
							
						</div> -->

						<div ref="menuicon"  style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
							<el-dropdown trigger="click" @command="changeLanguage">
								<span class="el-dropdown-link">
									<!-- 添加徽标组件 -->
									<el-badge 
										:value="notificationCount" 
										:max="99"
										class="badge-notification"
										:hidden="notificationCount === 0"
									>
										<i class="iconfont icon-tongzhi ml-1"></i>
									</el-badge>
								</span>
								
								<el-dropdown-menu 
									slot="dropdown" 
									class="message-dropdown"
								>
									<div class="message-header">
										<span>{{$t('layout.noReadMsg')}}（{{notificationCount}}）</span>
									</div>
									
									<div class="message-list">
									<template v-if="unreadMessages.length > 0">
										<div 
										v-for="(msg, index) in unreadMessages"
										:key="msg.id"
										class="message-item"
										style="border-bottom:1px solid #ebeef5;"
										>
										<div class="message-content" >
											<div class="message-title">
												{{ msg.title }}
											</div>
											<div class="message-body" v-if="msg.content.length > 20" v-html="msg.content.substring(0, 20)+'....'"></div>
											<div class="message-body" v-else v-html="msg.content"></div>
											<div class="message-time">{{ msg.create_time }}</div>
										</div>
										<!-- <el-divider v-if="index < unreadMessages.length - 1" /> -->
										</div>
									</template>
									<div v-else class="empty-message">
										{{$t('layout.noMessgae')}}
									</div>
									</div>
									<div class="message-header text-blue">
										<span @click="toMsg"  style="cursor: pointer;">{{$t('layout.lookMax')}}<i class="iconfont icon-tiaozhuan-zhuanqu"></i></span>
									</div>
								</el-dropdown-menu>
							</el-dropdown>
						</div>
						<div ref="menuicon" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
							<el-dropdown trigger="hover" @command="changeLanguage">
							<span class="el-dropdown-link">
								{{ currentLangLabel }}
								<i  class="iconfont icon-yuyan ml-1"></i>
							</span>
							
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="cn">中文</el-dropdown-item>
								<el-dropdown-item command="en">English</el-dropdown-item>
							</el-dropdown-menu>
							</el-dropdown>
						</div>
						<!-- <div ref="menuicon" class="ml-4" @click="showUserInfoModel(1)" style="color: #545c64; font-size: 22px; cursor: pointer;padding:20px">
							12
						</div> -->
						<el-menu :default-active="navBar.active" mode="horizontal" @select="handleSelect"  style="height: 60px;border: unset;"
						menu-trigger="click">
						
							<el-submenu index="100">
								<template slot="title">
									<el-avatar size="small" :src="user.head?user.head:user_mo"></el-avatar>
									<span v-show="!is_phone" class="ml-1">{{user.name}}</span>
								</template>
								<el-menu-item class="top-right-but"  index="100-1"><i class="el-icon-user"></i>{{$t('layout.up_info')}}</el-menu-item>
								<el-menu-item class="top-right-but"  index="100-3"><i class="el-icon-key"></i>{{$t('layout.up_pass')}}</el-menu-item>
								<el-menu-item class="top-right-but"  index="100-4"><i class="el-icon-lock"></i>{{$t('layout.safeSet')}}</el-menu-item>
								
								<el-menu-item class="top-right-but"  index="100-5"><i class="el-icon-s-help"></i>{{$t('layout.apiSet')}}</el-menu-item>
								<el-menu-item class="top-right-but"  index="100-2"><i class="el-icon-switch-button"></i>{{$t('layout.Logout')}}</el-menu-item>

							</el-submenu>
						</el-menu>
						
					</el-header>
					<div style="z-index: 20;position: relative;padding:20px ">
						<!-- 面包屑导航 -->
						<div class="mb-3 bg-white" style="padding: 20px;margin: -20px;" v-if="bran.length > 0">
							<div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
								<!-- 靠左的 el-breadcrumb -->
								<el-breadcrumb  style="width: 200px;font-size:20px;font-weight:800;">
									{{$t('router.'+branTitle)}}
								</el-breadcrumb>

								<!-- 靠右的 el-breadcrumb -->
								<el-breadcrumb separator="/"  style="text-align: right;">
									<el-breadcrumb-item style="font-size:18px;font-weight:100;color:#303133" v-for="(item, index) in bran" :key="index" :to="{ path: item.path }">
										{{$t('router.'+item.title)}}
									</el-breadcrumb-item>
								</el-breadcrumb>
							</div>
						</div>
						<!-- 主内容 -->
						<router-view ref="contentMain"></router-view>
						<el-backtop target=".el-main" :bottom="100">
							<div style="{
								height: 100%;
								width: 100%;
								/* background-color: #f2f5f6; */
								box-shadow: 0 0 6px rgba(0,0,0, .12);
								text-align: center;
								line-height: 40px;
								color: #1989fa;
							}">
								
							</div>
						</el-backtop>
					</div>
					

				</el-main>
			</el-container>
		</el-container>

		<!-- 修改密碼 -->
		<pass-mode :isphone="is_phone" :passModel="passModel" @hide="hidePassModel"></pass-mode>

		<!-- 修改个人资料 -->
		<info-edit :isphone="is_phone" :infoModel="infoModel" @hide="hideInfoModel"></info-edit>

		<!-- 快递查询 -->
		<expressInfo :isphone="is_phone" :expressData="expressData" :expressModel="expressModel" @hide="hideExpressModel"></expressInfo>
		
		
		<!-- 安全设置 -->
		<googleMode :isphone="is_phone" :googleModel="googleModel"  @hide="hideGoogleModel"></googleMode>
		
		<!-- 访问管理 -->
		<apikeyMode :isphone="is_phone" :apikeyModel="apikeyModel"  @hide="hideApiKeyModel"></apikeyMode>

		<!-- 个人资料 -->
		<!-- <user-info :isphone="is_phone" :userInfoModel="userInfoModel" :userId="userId" @hide="hideUserInfoModel"></user-info> -->
	</div>
</template>

<script>
	import defaultLogo from '@/assets/img/logo.png';
	import common from '@/common/mixins/common.js';
	import passMode from '../components/common/pass-mode.vue';
	import { mapActions } from 'vuex';
	import infoEdit from '../components/common/info-edit.vue';
	import expressInfo from '../components/common/express-info.vue';
	// import userInfo from '../components/common/user-info.vue';
	import googleMode from '../components/common/google-mode.vue';
	import apikeyMode from '../components/common/apikey-mode.vue';

	import elementLocale from 'element-ui/lib/locale';
	import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
	import enLocale from 'element-ui/lib/locale/lang/en';

	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {

		mixins: [common],
		components: {
			apikeyMode,
			passMode,
			infoEdit,
			expressInfo,
			googleMode
			// userInfo
		},
		provide() {
			return {
				layout: this
			}
		},
		data() {
			return {
				apikeyModel:false,
				defaultLogo,
				language: localStorage.getItem('language') || 'cn', // 读取本地存储的语言
				langOptions: {
					'cn': '中文',
					'en': 'English'
				},
				googleModel:false,
				notificationCount:0,
				unreadMessages:[],

				userInfoModel: false,
				userId: 0,



				num_list:{},
				isCollapse:false,
				infoModel: false,
				expressModel:false,
				expressData:[],
				user_mo: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
				bran: [],
				branTitle: '',
				passModel: false,
				loading: false,
				webSocket:null,
				scoketUrl: 'wss://apics.ffcloudcdn.cc:2348?xuan_type=admin_web&token='+window.sessionStorage.getItem('token'),
				screenWidth: 0,
				is_phone:false,
				menuwidth:'auto',
				menuClass:'',
				index_p:{
					gutter:20,
					span1:9,
					span3:6,
					span2:12,
					gutter2:60,
					cardwidth:''
				},

				slideMenuActive: localStorage.getItem('slideMenuActive') || '0', // 默认选中首页
			}
		},
		created() {
			//初始化菜單信息
			// this.navBar = this.$conf.navBar
			//this._isMobile()
			// 面包屑导航信息
			this.getRouterBran()
			// 初始化选中菜單
			this.__initNavBar()
			// this.initSocket()
			this.getPageNum()
			this.newTreeDara()
		
		},
		destroyed() {
			// 页面销毁關閉连接
			// this.webSocket.close()
		},
		mounted() {
			const savedIndex = localStorage.getItem('slideMenuActive');
			if (savedIndex) {
				this.slideMenuActive = savedIndex;
			}
			// console.log(this.slideMenuActive)
			this.$nextTick(() =>{
				window.addEventListener('resize', this.handleResize);
				this.handleResize();
			});
		},
		watch: {
			'$route'(to, from) {
				let is_check = false
				this.navBar.active = '0'
				//console.log(123123)
				for(let i = 0;i<this.navBar.list[0].submenu.length;i++){
					 if(is_check){
						 break
					 }
					if(this.navBar.list[0].submenu[i].child.length==0){
						//console.log(to.name)
						if(this.navBar.list[0].submenu[i].pathname==to.name){
							this.slideMenuActive = i.toString()
							is_check = true
							break
						}
					}else{
						for(let j = 0;j<this.navBar.list[0].submenu[i].child.length;j++){
							if(this.navBar.list[0].submenu[i].child[j].pathname==to.name){
								this.slideMenuActive = i+'_'+j
								is_check = true
								break
							}
						}
					}
				}
				localStorage.setItem('navActive', JSON.stringify({
				 	top: this.navBar.active,
				 	left: this.slideMenuActive
				}))
				this.getRouterBran()
				//console.log(this.slideMenuActive)
			},
			
			isCollapse(newVal,oldVal){
				this.menuwidth = 'auto'
				if(newVal){
					if(this.is_phone){
						this.menuwidth = '0'
					}
				}				
			}
		},
		computed: {
			currentLangLabel() {
				return this.langOptions[this.language]; // 获取当前语言的名称
			},
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar
			}),
			// slideMenuActive: {
			// 	get() {
			// 		let item = this.navBar.list[this.navBar.active]
			// 		return item ? item.subActive : '0'
			// 	},
			// 	set(val) {
			// 		let item = this.navBar.list[this.navBar.active]
			// 		if (item) {
			// 			item.subActive = val
			// 		}
			// 	}
			// },
			
			slideMenus() {
				let item = this.navBar.list[this.navBar.active]
				return item ? item.submenu : []
			}
			
		},
		
		methods: {
			toMsg(){
				this.$router.push({
					name: 'data_message'
				})
			},
			changeLanguage(lang) {
				if(this.language==lang){
					return false
				}
				this.language = lang;
				this.$i18n.locale = lang;
				localStorage.setItem('language', lang);
				
				elementLocale.use(lang === 'cn' ? zhLocale : enLocale);
				this.$message.success(this.$t('message.switchSuccess'));
				// 刷新页面（强制重新加载应用）
				window.location.reload(); // 最直接的方式
			},
			newTreeDara(){

			  this.axios.post('/admin/user/pageData', {}, { token: true }).then(res => {
			    if (res.data.code !== 1) return;
				

			
			    const info = res.data.data.list;
			    const topList = info.top_list || [];
				//存储按钮规则
				window.sessionStorage.setItem('ruleNames', JSON.stringify(info.ruleNames))
				
				
			    // ① 生成“稳定签名”：按 sort/id 排序，只取关键字段，避免无意义抖动
			    const sortBy = (a, b) =>
			      ((a?.sort ?? 0) - (b?.sort ?? 0)) || ((a?.id ?? 0) - (b?.id ?? 0));
			
			    const normalize = (arr) => (arr || []).map(top => ({
			      id: top.id,
			      name: top.name,
			      sort: top.sort ?? 0,
			      // 二级
			      child: (top.child || []).slice().sort(sortBy).map(v => ({
			        id: v.id,
			        name: v.name,
			        sort: v.sort ?? 0,
			        // 前端真正用的路由键
			        pathname: v.desc || v.pathname || '',
			        // 三级
			        child: (v.child || []).slice().sort(sortBy).map(i => ({
			          id: i.id,
			          name: i.name,
			          sort: i.sort ?? 0,
			          pathname: i.desc || i.pathname || ''
			        }))
			      }))
			    }));
			
			    const newSig = JSON.stringify(normalize(topList));
			    const oldSig = localStorage.getItem('navSig') || '';
			
			    // ② 若菜单签名未变化：跳过提交与校正
			    window.sessionStorage.setItem('rules', JSON.stringify(info.rules));
			
			    // ③ 只有变化时才真正更新菜单
			    this.$store.commit('createNavBar', topList);
			    localStorage.setItem('navSig', newSig);
			
			    // ④ 变化后再做一次索引校正（防止本地缓存越界）
			    this.$nextTick(() => {
			      const [iStr, jStr] = (this.slideMenuActive || '0').split('_');
			      const i = Number(iStr) || 0;
			      const j = Number(jStr);
			
			      const hasLv2 = !!this.slideMenus[i];
			      const hasLv3 = Number.isInteger(j) ? !!(this.slideMenus[i]?.child?.[j]) : true;
			
			      if (!hasLv2 || !hasLv3) this.slideMenuActive = '0';
			      // 如需自动跳转，放开下一行
			      // this.toUrl();
			    });
			
			    // 规则持久化（保持原逻辑）
			    if (info.role && info.role.rules) {
			      window.sessionStorage.setItem('rules', JSON.stringify(info.role.rules));
			    }
			  }).catch(err => {
			    // 失败处理…
			  });
			},
			...mapActions(['triggerRefresh']),
				refreshPage() {
				this.triggerRefresh(); // 触发刷新
			},
			handleResize() {
				this.screenWidth = window.innerWidth;
				if(this.screenWidth<768){
					this.is_phone = true
				}else{
					this.is_phone = false
				}
				this.phoneHtml()
			},
			phoneHtml(){
				if(this.is_phone){
					this.isCollapse = true
					// this.$refs.logowidth.style.display = 'none';
					// this.$refs.memuicon.classList.remove('ml-4');
					this.menuClass = 'menu_float';
					if(this.isCollapse){
						this.menuwidth = '0'
					}else{
						this.menuwidth = 'auto'
					}
					this.index_p = {
						gutter:10,
						span1:24,
						span3:24,
						span2:24,
						gutter2:0,
						cardwidth:'110px'
					}
				}else{
					// this.$refs.logowidth.style.display = 'block';
					// this.$refs.memuicon.classList.add('ml-4');
					this.menuClass = '';
					this.menuwidth = 'auto'
					
					this.index_p = {
						gutter:20,
						span1:9,
						span3:6,
						span2:12,
						gutter2:60,
						cardwidth:'160px'
					}
				}
				
			},
			// 建立连接
			initSocket() {
				// 有參數的情况下：
				// 没有參數的情况:接口
				// let url1 = 'ws://localhost:9998'
				this.webSocket = new WebSocket(this.scoketUrl)
				this.webSocket.onopen = this.webSocketOnOpen
				this.webSocket.onclose = this.webSocketOnClose
				this.webSocket.onmessage = this.webSocketOnMessage
				this.webSocket.onerror = this.webSocketOnError

			},
			// 建立连接成功後的狀態
			webSocketOnOpen() {
				console.log('websocket连接成功amdin');
			},
			// 获取到後台消息的事件，操作數据的代碼在onmessage中书写
			webSocketOnMessage(res) {
				// res就是後台实时傳过来的數据
				if(res.data.indexOf("apiSendXuanMessage") >= 0 ) {
					let list = JSON.parse(res.data);
					console.log(list)
					 if(list.type=='apiSendXuanMessage'){
					 	let data = list.data
						if(data.type==1){
							this.getPageNum()
						}
					 }
				} 
				//给後台發送數据
				//this.webSocket.send("發送數据");
			},
			// 關閉连接
			webSocketOnClose() {
				this.webSocket.close()
				console.log('websocket连接已關閉');
			},
			//连接失敗的事件
			webSocketOnError(res) {
				console.log('websocket连接失敗');
				// 打印失敗的數据
				//console.log(res);
			},
			
			commonTo(name,data={}){
				let is_check = false
				this.navBar.active = '0'
				for(let i = 0;i<this.navBar.list[0].submenu.length;i++){
					if(is_check){
						 break
					}
					
					if(this.navBar.list[0].submenu[i].child.length==0){
						if(this.navBar.list[0].submenu[i].pathname==name){
							
							this.slideMenuActive = i.toString()
							is_check = true
							break
						}
					}else{
						for(let j = 0;j<this.navBar.list[0].submenu[i].child.length;j++){
						
							if(this.navBar.list[0].submenu[i].child[j].pathname==name){
								
								this.slideMenuActive = i+'_'+j
								//console.log(this.navBar.list[0].submenu[i])
								//console.log(this.slideMenuActive)
								is_check = true
								break
							}
						}
					}
				 	
					
				 }
				this.toUrl(data)
				
			},
			
			__initNavBar() {
				let r = localStorage.getItem('navActive')
				//console.log(r)
				if (r) {
					r = JSON.parse(r)
					this.navBar.active = r.top
					this.slideMenuActive = r.left
					this.toUrl()
				}
			},
			
			
			_isMobile() {
			 //        let flag =             navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
					
				// if(flag){
				// 	this.is_phone = false
				// }else{
				// 	this.is_phone = true
				// }
			 //    console.log(flag)
			},
			
			
			showExpressModel(data){
			
				 this.expressData.e_number = data
				 this.expressData.activities = []
				 this.expressData.is_data = 0
				 
				this.axios.post('/admin/data/checkExpressData', {e_number:data}, {
				 	token: true,
					loading: true
				 }).then(res => {
				 	let all = res.data
					if(all.code==1){
						
						if(all.data.list.list.length>0){
							this.expressData.activities = all.data.list.list
							this.expressData.is_data = 1
						}
						this.expressModel = true
					}
				 	//this.getPageNum()
				 }).catch(err => {
				 	// 失敗
					this.expressModel = true
				 })
			
				
			},
			hideExpressModel() {
				this.expressModel = false
			},
			
			handleEdit(){
				this.isCollapse = !this.isCollapse
			},
			//页面未處理數量
			getPageNum() {
				this.axios.post('/admin/user/adminPageNum', {}, {
					token: true,
				}).then(res => {
				
					let all = res.data
					let list = all.data.list
					this.notificationCount = list.msgCount
					this.unreadMessages = list.msgList
					
				}).catch(err => {
					// 失敗
					
				})
			},
			// 获取面包屑导航信息
			getRouterBran() {
				let b = this.$route.matched.filter(v => v.name)
				let arr = []
				b.forEach((v, k) => {
					if (v.name === 'index' || v.name === 'layout') return
					arr.push({
						name: v.name,
						path: v.path,
						title: v.meta.title
					})
					this.branTitle = v.meta.title;
				})
				if (arr.length > 0) {
					arr.unshift({
						name: 'index',
						path: '/index',
						title: 'home'
					});
				}
				this.bran = arr
			},
			hideInfoModel() {
				let user = JSON.parse(window.sessionStorage.getItem('user'))
				this.user.name = user.name
				this.user.head = user.head
				this.user.username = user.username
				this.user.cms_name = user.cms_name
				this.user.cms_logo = user.cms_logo
				this.user.is_cms_logo = user.is_cms_logo
				this.infoModel = false
			},
			showUserInfoModel(uid){
				this.userId = uid
				this.userInfoModel = true
			},
			hideUserInfoModel() {
				this.userInfoModel = false
			},
			hidePassModel() {
				this.passModel = false
			},
			hideGoogleModel(){
				this.googleModel = false
			},
			hideApiKeyModel(){
				this.apikeyModel = false
			},
			handleSelect(key, keyPath) {
				if(key== '200'){
					return false
				}
				if (key === '100-1') {
					return this.infoModel = true
				}
				if (key === '100-3') {
					return this.passModel = true
				}
				if (key === '100-4') {
					return this.googleModel = true
				}
				if (key === '100-5') {
					return this.apikeyModel = true
				}
				if (key === '100-2') {
					//退出
					return this.logout();
				}
				this.navBar.active = key;
				// 跳转到當前激活
				this.slideMenuActive = '0'
				if (this.slideMenus.length > 0) {
					this.$router.push({
						name: this.slideMenus[this.slideMenuActive].pathname
					})
				}
			},
			logout() {
				//請求接口
				this.axios.post('/admin/user/logout', {}, {
					token: true,
					loading: true
				}).then(res => {
					//成功後
					this.$message(this.$t('message.logout_ok'))
					this.$store.commit('logout')
					//返回到登錄页
					this.$router.push({
						name: 'login'
					})
				}).catch(err => {
					//失敗
					this.$message(this.$t('message.logout_ok'))
					this.$store.commit('logout')
					this.$router.push({
						name: 'login'
					})
				})
			},
			slideSelect(key, keyPath) {
				localStorage.setItem('domainDetail', '');
				localStorage.setItem('commonDetailPage', '');
				this.slideMenuActive = key
				if(this.is_phone){
					this.isCollapse = true
				}
				localStorage.setItem('slideMenuActive', key); // 保存选中状态
				this.toUrl();
			},
			toUrl(data={}) {
				let keys = new Array(); //定义一數組
				keys = this.slideMenuActive.split("_");
				if (keys.length === 2) {
					if(localStorage.getItem('commonDetailPage')){
						let commonDetailPage = JSON.parse(localStorage.getItem('commonDetailPage'));
						if(this.slideMenus[keys[0]].child[keys[1]].pathname==commonDetailPage.page){
							this.$router.push({
								name: commonDetailPage.url,
							})
						}
						
					}else{
						if(this.slideMenus[keys[0]].child[keys[1]].pathname=='cdn_domain' && localStorage.getItem('domainDetail')){
							this.$router.push({
								name: 'cdn_detail',
							})
						}else{
							this.$router.push({
								name: this.slideMenus[keys[0]].child[keys[1]].pathname
							})
						}
					}
					
					
					
				} else {
					//跳转到指定页面
					this.$router.push({
						name: this.slideMenus[this.slideMenuActive].pathname,
						params:data
					})
				}
			},

		}
	}
</script>
<style lang="scss">
	.message-dropdown {
		width: 360px;
		padding: 0 !important;
		
		.message-header {
			padding: 12px 16px;
			border-bottom: 1px solid #ebeef5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;
			
		}

		.message-list {
			max-height: 400px;
			overflow-y: auto;
			
			.message-item {
				padding: 12px 16px;
				cursor: pointer;
				transition: background 0.3s;
				
				&:hover {
					background: #f5f7fa;
				}
				
				&.unread {
					background: #f0faff;
				}
			}
			
			.message-content {
				position: relative;
				
				.dot {
					position: absolute;
					left: -8px;
					top: 50%;
					transform: translateY(-50%);
					width: 6px;
					height: 6px;
					background: #f56c6c;
					border-radius: 50%;
				}
			}
			
			.message-title {
			font-weight: 400;
			color: #303133;
			margin-bottom: 4px;
			font-size: 14px;
			}
			
			.message-body {
			font-size: 12px;
			color: #606266;
			line-height: 1.5;
			// @include text-ellipsis(2);
			}
			
			.message-time {
			font-size: 12px;
			color: #909399;
			margin-top: 4px;
			}
			
			.empty-message {
			padding: 20px;
			text-align: center;
			color: #909399;
			}
		}
		
		.el-divider {
			margin: 8px 0;
		}
	}

	
	.top-right-but{
		i{
			font-size: 14px!important;
		}
	}
	
	.left-menu-class .el-submenu__title:hover{
		background-color: transparent!important;
		span, i {
					color: #ff9561;
				}
	}
	.left-menu-class .el-menu-item:hover, .el-menu-item:focus{
		background-color: transparent!important;
		span, i {
					color: #ff9561;
				}
	}
	// .left-menu-class .el-breadcrumb__inner.is-link:hover, .el-breadcrumb__inner a:hover {
	// 	color: #ff9561;
	// 	cursor: pointer;
	// }
	.left-menu-class .el-breadcrumb__inner.is-link, .el-breadcrumb__inner a {
		font-weight: 200!important;
	}
	.left-menu-class .el-breadcrumb__separator{
		font-weight: 200!important;
	}
	.left-menu-class .xial{
		height: 46px!important;
		line-height: 46px!important;
	}
	.left-menu-class .el-submenu .el-menu-item{
		height: 46px!important;
		line-height: 46px!important;
	}
	.left-menu-class .el-submenu__title{
		height: 46px!important;
		line-height: 46px!important;
	}
	.left-menu-class{
		span {
			font-size: 14px;
		}
		i {
			font-size: 16px!important;
			margin-right: 10px!important;
		}
		
	}






	.el-dropdown-link {
		color: #545c64;
		font-size: 14px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}					
	.icon {
		width: 1em;
		height: 1em;
		vertical-align: -0.15em;
		fill: currentColor;
		overflow: hidden;
	}
	
	.el-menu-vertical-demo:not(.el-menu--collapse) {
	    width: 200px;
	  }
	  
	  .avatar-uploader .el-upload {
	      border: 1px dashed #d9d9d9;
	      border-radius: 6px;
	      cursor: pointer;
	      position: relative;
	      overflow: hidden;
	    }
	    .avatar-uploader .el-upload:hover {
	      border-color: #409EFF;
	    }
	    .avatar-uploader-icon {
	      font-size: 28px;
	      color: #8c939d;
	      width: 178px;
	      height: 178px;
	      line-height: 178px;
	      text-align: center;
	    }
	    .avatar {
	      width: 178px;
	      height: 178px;
	      display: block;
	    }
	
		
		.tis_btn {
			width: 30px;
			    height: 30px;
			    line-height: 30px;
			    padding: 0!important;
		}
		.money_text {
			color: #dc3545 !important;
			font-weight: bold !important;
		}

	.content_huan{
		word-wrap: break-word !important;/* 單词换行 */
		word-break: break-word !important; /* 支持非標准浏览器 */
		white-space: pre-wrap !important; /* 保留空格和换行符 */
	}
	.el-dialog__title{
		font-size: 16px!important;
	}
	
	.test{
		
	}
	
</style>
